// extracted by mini-css-extract-plugin
export default {"createBtnWrap":"CustomDDTask_createBtnWrap__yT22s","plusIcon":"CustomDDTask_plusIcon__DbyU+"};